const workspacePathByDataset: Record<string, string> = {
	dev: "development",
	prod: "production",
};

const deployedStudioUrlByDataset: Record<string, string> = {
	dev: "https://solstice-v2-cms-develop.vercel.app",
	prod: "https://solstice-v2-cms.vercel.app",
};

type StudioBaseUrlOptions = {
	dataset: string | undefined;
	nodeEnv: string | undefined;
	studioUrl?: string;
	developmentStudioUrl?: string;
	productionStudioUrl?: string;
};

export function getStudioBaseUrl({
	dataset,
	nodeEnv,
	studioUrl,
	developmentStudioUrl,
	productionStudioUrl,
}: StudioBaseUrlOptions) {
	if (nodeEnv === "development") {
		return studioUrl ?? "http://localhost:3333";
	}

	if (dataset === "dev") {
		return developmentStudioUrl ?? deployedStudioUrlByDataset.dev;
	}

	if (dataset === "prod") {
		return productionStudioUrl ?? deployedStudioUrlByDataset.prod;
	}

	return studioUrl ?? "http://localhost:3333";
}

export function getStudioUrl(baseUrl: string, dataset: string | undefined) {
	const url = new URL(baseUrl);
	const workspacePath = dataset ? workspacePathByDataset[dataset] : undefined;
	const basePath = url.pathname.replace(/\/+$/, "");

	url.hash = "";
	url.search = "";

	url.pathname =
		workspacePath && !basePath.endsWith(`/${workspacePath}`)
			? `${basePath}/${workspacePath}`
			: basePath || "/";

	return url.toString().replace(/\/+$/, "");
}
